import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button, Form, Modal } from "react-bootstrap";
import { getStore } from "../../store";
import I18n from "lib/I18n";
import { usePublisher } from "bundles/BigqueryQueryViewer/lib/pubsub";

const CreateModal = observer(() => {
  const store = getStore().explorer.sharedQuery;

  const onClose = () => {
    store.isCreateOpen = false;
  };

  const onCreate = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    store.create();
  };

  return (
    <Modal show={store.isCreateOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {I18n.t("bigquery_query_viewer.label.create_shared_query")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{I18n.t("bigquery_query_viewer.messages.create_shared_query")}</p>
        <Form onSubmit={onCreate}>
          <Form.Group>
            <Form.Label>
              {I18n.t("bigquery_query_viewer.label.shared_query_name")}
            </Form.Label>
            <Form.Control
              placeholder={I18n.t(
                "bigquery_query_viewer.label.shared_query_name",
              )}
              value={store.name}
              ref={(node) => node?.focus()}
              onChange={(e) => (store.name = e.currentTarget.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {I18n.t("bigquery_query_viewer.label.cancel")}
        </Button>
        <Button
          variant="primary"
          disabled={!store.name.trim() || store.isCreating}
          onClick={onCreate}
        >
          {I18n.t("bigquery_query_viewer.label.create")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

const DeleteModal = observer(() => {
  const store = getStore().explorer.sharedQuery;
  const publisher = usePublisher();

  const onClose = () => {
    store.isDeleteOpen = false;
  };

  const onDelete = async (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (await store.delete()) {
      publisher.publish(store.selectedSharedQuery, "deleted");
    }
  };

  return (
    <>
      <Modal size="lg" show={store.isDeleteOpen} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {I18n.t("bigquery_query_viewer.label.manage_shared_query")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
              {I18n.t(
                "bigquery_query_viewer.messages.delete_shared_query_confirm",
              )}
            </p>
            <Form onSubmit={onDelete}>
              <Form.Group>
                <Form.Label>
                  {I18n.t("bigquery_query_viewer.label.shared_query_name")}
                </Form.Label>
                <Form.Control
                  placeholder={I18n.t(
                    "bigquery_query_viewer.label.shared_query_name",
                  )}
                  value={store.selectedSharedQuery?.name}
                  readOnly
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  {I18n.t("bigquery_query_viewer.label.shared_query_creator")}
                </Form.Label>
                <Form.Control
                  placeholder={I18n.t(
                    "bigquery_query_viewer.label.shared_query_name",
                  )}
                  value={store.selectedSharedQuery?.userName}
                  readOnly
                />
              </Form.Group>
              <div className="mt-2 float-end">
                <Button
                  variant="light"
                  className="me-2"
                  onClick={() => (store.isDeleteOpen = false)}
                >
                  {I18n.t("bigquery_query_viewer.label.cancel")}
                </Button>
                <Button variant="danger" onClick={onDelete}>
                  {I18n.t("bigquery_query_viewer.label.delete")}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
});

export const SharedQuery = observer(() => {
  return (
    <>
      <CreateModal />
      <DeleteModal />
    </>
  );
});
